// Central source of truth for how positions are labeled and grouped in the
// UI. Keep this in sync with models/Advert.js POSITIONS on the backend.

export const POSITION_GROUPS = [
  {
    group: "Flight",
    positions: [
      { value: "FLIGHT_HOME", label: "Flight Home" },
      { value: "FLIGHT_RESULTS", label: "Flight Results" },
      { value: "FLIGHT_PASSENGER_FORM", label: "Passenger Info Form" },
      { value: "FLIGHT_ADDONS", label: "Flight Add-ons" },
      { value: "FLIGHT_PAYMENT", label: "Flight Payment" },
    ],
  },
  {
    group: "Event",
    positions: [
      { value: "EVENT_RESULTS", label: "Event Results" },
      { value: "EVENT_DETAILS", label: "Event Details" },
      { value: "EVENT_REGISTRATION", label: "Event Registration" },
      { value: "EVENT_ADDONS", label: "Event Add-ons" },
      { value: "EVENT_PAYMENT", label: "Event Payment" },
    ],
  },
  {
    group: "Other",
    positions: [
      { value: "AUTHENTICATION", label: "Authentication" },
      { value: "CAMPAIGNS", label: "Campaigns" },
    ],
  },
];

export const ALL_POSITION_OPTIONS = POSITION_GROUPS.flatMap((g) => g.positions);

export const positionLabel = (value) => {
  if (value === "*") return "All Positions";
  const found = ALL_POSITION_OPTIONS.find((p) => p.value === value);
  return found ? found.label : value;
};

// The summary endpoint groups wildcard ("*") ads under their own "*"
// bucket rather than folding them into every position's totals (unlike
// findServable, which does fold them in). This merges the "*" bucket's
// numbers into every specific position so counts shown in the UI reflect
// what would actually serve there. Ideally getAdvertsSummary is fixed to
// do this server-side later — this is a client-side stopgap.
export const mergeWildcardIntoSummary = (summary = []) => {
  const wildcard = summary.find((s) => s.position === "*");
  const byPosition = new Map(summary.map((s) => [s.position, { ...s }]));

  ALL_POSITION_OPTIONS.forEach(({ value }) => {
    const existing = byPosition.get(value) || {
      position: value,
      totalAds: 0,
      totalImpressions: 0,
      totalClicks: 0,
      ctr: 0,
    };
    if (wildcard) {
      existing.totalAds += wildcard.totalAds;
      existing.totalImpressions += wildcard.totalImpressions;
      existing.totalClicks += wildcard.totalClicks;
    }
    byPosition.set(value, existing);
  });

  return byPosition;
};
